import React from "react";
import Card from "src/componets/Card";
import { AssetInterface } from "src/store/community/assetsSlice";

const _Details = ({ asset }: { asset: AssetInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Description</h4>
        {asset?.description}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {asset?.search_text}
      </Card>
    </>
  );
}

export default _Details;
